import { createSlice } from "@reduxjs/toolkit";
// eslint-disable-next-line no-duplicate-imports
import type { PayloadAction } from "@reduxjs/toolkit";
import type { LoanDto, CardResponseDto } from "@src/api-new/generated-api.schemas";

import type { CommPreferences, PaymentPlan, SubmitAddNewCardPayload, SubmitPaymentPlanPayload } from "./Restructure.types";


interface RestructureState {
  paymentPlan?: PaymentPlan,
  agreementType?: string,
  customerAccounts?: any[],
  availableDates?: string[],
  currentTime?: string | Date,
  holidays?: string[],
  communicationPreferences?: CommPreferences,
  loan?: LoanDto,
  cards?: CardResponseDto[],
  termsAndConditions?: any,
  loanExplanation?: any,
  bizumPaymentOptionEnabled?: boolean,
}

const initialState: RestructureState = {
};

const restructureSlice = createSlice({
  name: "restructure",
  initialState,
  reducers: {
    setPaymentPlan(state, action: PayloadAction<PaymentPlan | undefined>) {
      state.paymentPlan = action.payload;
    },
    getAgreementsStart(state, action: PayloadAction<any>) {
      state.agreementType = action.payload;
    },
    getAgreementsSuccess(state, action) {
      state.termsAndConditions = action.payload.termsAndConditions;
      state.loanExplanation = action.payload.loanExplanation;
    },
    passCustomerAccounts(state, action: PayloadAction<any>) {
      state.customerAccounts = action.payload;
    },
    getAvailableDates(state, action: PayloadAction<string[]>) {
      state.availableDates = action.payload;
    },
    passCurrentTime(state, action: PayloadAction<string | Date>) {
      state.currentTime = action.payload;
    },
    getHolidaysList(state, action: PayloadAction<string[]>) {
      state.holidays = action.payload;
    },
    getCommunicationPreferences(state, action: PayloadAction<CommPreferences>) {
      state.communicationPreferences = action.payload;
    },
    getLoan(state, action: PayloadAction<LoanDto>) {
      state.loan = action.payload;
    },
    getCards(state, action: PayloadAction<CardResponseDto[]>) {
      state.cards = action.payload;
    },
    checkActivePaymentOptionsSuccess(state, action) {
      state.bizumPaymentOptionEnabled = action.payload.bizumPaymentOptionEnabled;
    },
    submitPaymentPlanForm(state, action: PayloadAction<SubmitPaymentPlanPayload>) {
      return state;
    },
    submitAddNewCardForm(state, action: PayloadAction<SubmitAddNewCardPayload>) {
      return state;
    },
    destroy() {
      return initialState;
    }
  }
});


export default restructureSlice.reducer;
export const {
  setPaymentPlan,
  getAgreementsStart,
  getAgreementsSuccess,
  passCustomerAccounts,
  getAvailableDates,
  passCurrentTime,
  getHolidaysList,
  getCommunicationPreferences,
  getLoan,
  getCards,
  submitPaymentPlanForm,
  submitAddNewCardForm,
  destroy
} = restructureSlice.actions;
export const restructureActions = restructureSlice.actions;
